export default "__VITE_ASSET__BfuXTh1p__"